<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="card-title">Farmaci</h4>
                </div>
                <div class="col-md-6">
                  <fg-input type="text"
                          label=""
                          placeholder="Cerca..."
                          v-model="pattern">
                  </fg-input>
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-md-12 table-responsive">
                <l-table class="table-hover table-striped"
                         :columns="farmaciColumns"
                         :data="farmaci"
                         :url="url"
                         :pattern="pattern"
                         :getRowClass="farmaciRowClass"
                         @onClick="onClick">
                </l-table>
              </div>
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-info btn-fill" @click.prevent="newFarmaco">
                  Nuovo Farmaco
                </button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  
  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        url: process.env.API_URL + 'farmaco?withTrashed=true',
        farmaciColumns: [
          {
            key: 'nome',
            text: 'Nome'
          }
        ],
        farmaciRowClass: function (data) {
          return data.deleted_at ? 'text-danger' : ''
        },
        farmaci: [],
        pattern: this.$route.params.pattern
      }
    },
    methods: {
      onClick: function (data) {
        this.$root.$router.push('/dashboard/farmaco/' + data.id)
      },
      newFarmaco: function () {
        this.$root.$router.push('/dashboard/farmaco-new')
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/FarmacoList.vue